import React from 'react';
import { CheckIcon } from 'lucide-react';
type Level = {
  label: string;
  text: string;
};
type VolumeCardProps = {
  label: string;
  title: string;
  subtitle: string;
  points: string[];
  tagline?: string;
  levels?: Level[];
  afterPoints?: string[];
  finalLine: string;
  meta: string;
};
export function VolumeCard({
  label,
  title,
  subtitle,
  points,
  tagline,
  levels,
  afterPoints,
  finalLine,
  meta
}: VolumeCardProps) {
  return <article className="overflow-hidden rounded-md border border-line bg-white" data-id="element-199" data-mp="1uswjflhjz90a">
      <div className="flex items-center gap-2 bg-navy px-3 py-2" data-id="element-200" data-mp="1pvmjhbwjfey7">
        <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] bg-check" aria-hidden data-id="element-201" data-mp="1l3cupz75skxi">
          <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} data-id="element-202" data-mp="1h2t298xj65hp" />
        </span>
        <h3 className="font-heading text-[13px] font-extrabold uppercase leading-tight text-white md:text-[15px]" data-id="element-203" data-mp="2djnpad2c0h9x">
          {label} — {title}
        </h3>
      </div>
      <div className="px-3 py-2.5 md:px-4 md:py-3" data-id="element-204" data-mp="28r2xfh2zke91">
        <p className="font-heading text-[13px] font-bold leading-snug text-brand md:text-[14px]" data-id="element-205" data-mp="37bqx79aliepa">{subtitle}</p>
        {tagline && <p className="mt-1 font-heading text-[12px] font-extrabold uppercase leading-tight text-goldDark md:text-[13px]" data-id="element-206" data-mp="3cabup0ygqka1">
            {tagline}
          </p>}
        <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-207" data-mp="32k8uafp0i41o">
          {points.map(p => <p key={p} data-id="element-208" data-mp="2ok7rgup6smjk">{p}</p>)}
        </div>
        {levels && <dl className="mt-2 divide-y divide-line rounded-md border border-line bg-surface" data-id="element-209" data-mp="2tldnp2i22rxu">
            {levels.map(l => <div key={l.label} className="px-3 py-2 text-[14px] leading-[1.4] md:text-[15px]" data-id="element-210" data-mp="2epfwlymzodsh">
                <dt className="font-heading text-[12px] font-extrabold uppercase text-navy md:text-[13px]" data-id="element-211" data-mp="2joiqcmxiqxl5">{l.label}</dt>
                <dd className="mt-0.5 text-ink" data-id="element-212" data-mp="hv2wzia1r4mh">{l.text}</dd>
              </div>)}
          </dl>}
        {afterPoints && <div className="mt-2 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-213" data-mp="gep5cqtqjzj0">
            {afterPoints.map(p => <p key={p} data-id="element-214" data-mp="bgw2o7rn5nnh">{p}</p>)}
          </div>}
        <p className="mt-2 font-heading text-[12px] font-extrabold uppercase leading-tight text-brand md:text-[13px]" data-id="element-215" data-mp="6ghriguqtxl8">
          {finalLine}
        </p>
        <p className="mt-1 text-[12px] font-semibold text-ink/70 md:text-[13px]" data-id="element-216" data-mp="z445mj1lkkmc">{meta}</p>
      </div>
    </article>;
}